import { combineReducers } from 'redux';

import totes from './totes';
import peticioEstacionsEnCurs from './peticioEstacionsEnCurs';
import peticioDonarDeBaixaEstacioEnCurs from './peticioDonarDeBaixaEstacioEnCurs';
import formulari from './formulari';

export default combineReducers({
    totes,
    peticioEstacionsEnCurs,
    peticioDonarDeBaixaEstacioEnCurs,
    formulari
});



// WEBPACK FOOTER //
// ./src/reducers/estacio/index.js